// extracted by mini-css-extract-plugin
export default {"LeadershipChainList":"_9nH96KokoeAxTyxmh65CYdbuHWkuE3ZcZbq8hkZcwZg","Badge":"_5yi1haTPkh45daMkv7uadTDCQla-ggOLW65yVeK2Aec"};